export default "__VITE_ASSET__DMw03Q9v__"